import { Button } from '@givebutter/primitives/button';

const FilterSubmit = () => (
    <Button type={'submit'} variant="none" className={'sr-only'}>
        Submit filter
    </Button>
);

export { FilterSubmit };
